import React, { useState } from "react"
import { Collapse, Text } from "@quorumus/plum"
import {
    CollapseWrapper,
    StyledDateRow,
} from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CollapsibleKeyDatesSection/CollapsibleKeyDatesSection.styles"
import {
    CollapsibleKeyDatesSectionProps,
    KeyDateInfo,
} from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CollapsibleKeyDatesSection/CollapsibleKeyDatesSection.types"

export const CollapsibleKeyDatesSection: React.FC<CollapsibleKeyDatesSectionProps> = ({
    title,
    dates,
    defaultOpen = true,
    className,
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen)

    const handleToggle = () => {
        setIsOpen((prev) => !prev)
    }

    return (
        <CollapseWrapper className={className} isOpen={isOpen}>
            <Collapse in={isOpen} label={title} onToggle={handleToggle} data-plum-id="collapsible-key-dates-section">
                {dates.map((dateInfo: KeyDateInfo, index: number) => (
                    <StyledDateRow key={`${dateInfo.date}-${index}`} data-cy="date-row">
                        <Text>{dateInfo.date}</Text>
                        {dateInfo.url ? (
                            <a href={dateInfo.url} target="_blank" rel="noopener noreferrer">
                                {dateInfo.description} <i className="fa fa-external-link" aria-hidden="true"></i>
                            </a>
                        ) : (
                            <Text>{dateInfo.description}</Text>
                        )}
                    </StyledDateRow>
                ))}
            </Collapse>
        </CollapseWrapper>
    )
}
